//@ts-nocheck

'use client'

import React, { useContext, useState } from 'react'

import * as S from './BannerCarousel.styles'
import { Navigation, Scrollbar, A11y, EffectFade } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import useSwiperRef from '../../../hooks/useSwiperRef'
import Image from 'next/image'

import { Col, Container } from '../../atoms/GridSystem'
import { ButtonForwardingRef } from '../../atoms/Button/Button.component'

import { Paragraph } from '../../atoms/Typography/Typography.component'

import { SectionThemeContext } from '../../../contexts/SectionTheme.context'

const BannerCarousel = ({ steps }) => {
  const [currIndex, setCurrIndex] = useState(1)

  const [nextEl, nextElRef] = useSwiperRef()
  const [prevEl, prevElRef] = useSwiperRef()
  const [scrollbarEl, scrollbarElRef] = useSwiperRef()

  const { selectedColorScheme } = useContext(SectionThemeContext)
  
  return (
    <Container className="banner-carousel-container">
      <S.BannerCarouselWrapper className="banner-carousel-wrapper">
        <Swiper
          modules={[Navigation, Scrollbar, A11y, EffectFade]}
          slidesPerView={1}
          navigation={{
            prevEl,
            nextEl,
          }}
          scrollbar={{ el: scrollbarEl }}
          a11y={{
            prevSlideMessage: 'Precedente slide',
            nextSlideMessage: 'Prossima slide',
          }}
          effect="fade"
          onRealIndexChange={(swiper) => setCurrIndex(swiper.realIndex + 1)}  
          className="banner-carousel-swiper"
        >
          {steps.map((item, i) => (
            <SwiperSlide key={`CarouselCards-Item-${i}-${item?.id}`} className="banner-carousel-slide">
              <S.BannerCarouselSlide colorScheme={selectedColorScheme} className="banner-carousel-slide-content">
                <Col xs={12} lg={6} $noGutter $direction="column" className="banner-carousel-image-col">
                  <S.BannerCarouselSlideImage className="banner-carousel-slide-image">
                    <Image src={item.image.src} alt={item.image.alt} fill sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw" className="banner-carousel-image" />
                  </S.BannerCarouselSlideImage>
                </Col>
                <Col xs={12} lg={6} $noGutter $direction="column" className="banner-carousel-text-col">
                  <S.BannerCarouselSlideText colorScheme={selectedColorScheme} className="banner-carousel-slide-text">
                    {item?.tagline ? (
                      <Paragraph
                        typo="label"
                        content={item.tagline}
                        weight={'medium'}
                        className="banner-carousel-tagline"
                      />
                    ) : null}
                    {item?.title ? (
                      <Paragraph
                        typo="headingMD"
                        content={item.title}
                        weight={'medium'}
                        className="banner-carousel-title"
                      />
                    ) : null}
                    {item?.body ? (
                      <Paragraph
                        typo="paragraphLG"
                        content={item.body}
                        className="banner-carousel-body"
                      />
                    ) : null}
                  </S.BannerCarouselSlideText>
                </Col>
              </S.BannerCarouselSlide>
            </SwiperSlide>
          ))}
        </Swiper>
        { steps.length > 1 ? (
          <S.BannerCarouselScrollbarWrapper colorScheme={selectedColorScheme} className="banner-carousel-scrollbar-wrapper">
            <S.BannerCarouselScrollbar ref={scrollbarElRef} colorScheme={selectedColorScheme} className="banner-carousel-scrollbar"/>
          </S.BannerCarouselScrollbarWrapper>
        ) : null}
        { steps.length > 1 ? (
          <S.BannerCarouselControls className="banner-carousel-controls">
            <S.BannerCarouselControlsNav className="banner-carousel-controls-nav">
              <ButtonForwardingRef
                ref={prevElRef}
                variant="primary"
                iconEnd={'chevron-left'}
                iconEndSize="big"
                className="banner-carousel-prev-button"
              />
              <ButtonForwardingRef
                ref={nextElRef}
                variant="primary"
                iconEnd={'chevron-right'}
                iconEndSize="big"
                className="banner-carousel-next-button"
              />
            </S.BannerCarouselControlsNav>
          </S.BannerCarouselControls>
        ) : null}
      </S.BannerCarouselWrapper>
    </Container>
  )
}

export default BannerCarousel
